import React, { useEffect } from "react";
import Nav from "@/components/Nav";
import Footer from "@/components/Footer";
import ConversionBlock from "@/components/ConversionBlock";
import { ArrowRight } from "lucide-react";
import { Link } from "react-router-dom";

/** Reusable page header — eyebrow + h1 + lead */
export function PageHeader({ eyebrow, title, titleAccent, lead, number }) {
  return (
    <section
      className="bg-grid"
      style={{
        background: "var(--ink)",
        paddingTop: 140, paddingBottom: 64,
        position: "relative", overflow: "hidden",
      }}
    >
      <span className="bg-dot pulse" style={{ top: "30%", right: "10%" }} aria-hidden />
      <span className="bg-dot pulse" style={{ top: "70%", right: "22%", animationDelay: "0.8s", opacity: 0.5 }} aria-hidden />

      <div className="site-container" style={{ position: "relative", zIndex: 1 }}>
        <Link
          to="/" data-testid="page-back"
          style={{
            display: "inline-flex", alignItems: "center", gap: 8,
            color: "var(--text-dim)", textDecoration: "none",
            fontSize: 11, textTransform: "uppercase", letterSpacing: "0.16em",
            marginBottom: 32,
          }}
        >
          ← Vissza a főoldalra
        </Link>

        <div style={{ display: "flex", alignItems: "center", gap: 14, marginBottom: 20 }}>
          <span style={{ height: 1, background: "var(--gold)", width: 32 }} />
          <span className="eyebrow">{number ? `${number} · ` : ""}{eyebrow}</span>
        </div>
        <h1 className="h1" data-testid="page-h1" style={{ margin: 0, maxWidth: 920 }}>
          {title} {titleAccent && <span style={{ color: "var(--gold)" }}>{titleAccent}</span>}
        </h1>
        {lead && (
          <p className="lead" style={{ marginTop: 24, maxWidth: 600, fontSize: 16 }}>
            {lead}
          </p>
        )}
      </div>
    </section>
  );
}

/** Page shell — Nav + scroll-to-top + Footer */
export default function PageShell({ children, conversion = true }) {
  useEffect(() => { window.scrollTo(0, 0); }, []);
  return (
    <div style={{ background: "var(--ink)" }}>
      <Nav />
      <main>
        {children}
        {conversion && <ConversionBlock testId="page-conversion" />}
      </main>
      <Footer />
    </div>
  );
}

/** Strip used at bottom of pages to navigate to next */
export function PageNextStrip({ to, label, kicker }) {
  return (
    <section style={{ background: "var(--ink-2)", borderTop: "1px solid var(--line)", borderBottom: "1px solid var(--line)", padding: "40px 0" }}>
      <div className="site-container">
        <Link to={to} style={{ display: "flex", alignItems: "center", justifyContent: "space-between", textDecoration: "none", color: "var(--text)", gap: 24, flexWrap: "wrap" }}>
          <div>
            <span className="eyebrow-muted">{kicker}</span>
            <h3 className="h2" style={{ margin: "8px 0 0" }}>{label}</h3>
          </div>
          <ArrowRight size={28} color="var(--gold)" />
        </Link>
      </div>
    </section>
  );
}
